import React from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
// import { WithoutAuthRoute } from "./routes";
import ScrollToTop from "./helpers/ScrollToTop";
import ScrollToTopButton from "./helpers/ScrollToTopButton";
import GuestLayout from "./views/guest-portal/Layout";
import Home from "./views/guest-portal/pages/Home";
import Blog from "./views/guest-portal/pages/Blog";
import BlogDetail from "./views/guest-portal/pages/Blog/detail";
import Product from "./views/guest-portal/pages/Product";
import UseCases from "./views/guest-portal/pages/UseCases";
import HomeUseCases from "./views/guest-portal/partials/Home/HomeUseCases";
import FAQ2 from "./views/guest-portal/pages/Faq";
import Contact2 from "./views/guest-portal/pages/Contact";
import Pricing from "./views/guest-portal/pages/Pricing";
import TermsConditions from "./views/guest-portal/pages/TermsConditions";
import PrivacyPolicy from "./views/guest-portal/pages/PrivacyPolicy";
import PageNotFound from "./views/PageNotFound";
import RefundPolicy from "./views/guest-portal/pages/RefundPolicy";
import CustomerSupport from "./views/guest-portal/pages/CustomerSupport";
import Security from './views/guest-portal/pages/Security'
import FeaturesAll from './views/guest-portal/partials/Home/FeaturesAll';
import Integrations from "./views/guest-portal/pages/Integrations";

function App() {
       return (
              <>
                     <ScrollToTop />
                     <ScrollToTopButton />
                     <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick
                            rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="colored" />
                     <Routes>
                            {/* <Route path="/" element={<WithoutAuthRoute />}> */}
                            <Route path="/" element={<GuestLayout />}>
                                   <Route path='/' element={<Home />} />
                                   <Route path="/blog" element={<Blog />} />
                                   <Route path="/blog/:blog_url" element={<BlogDetail />} />
                                   <Route path="/blog/:blog_url" element={<BlogDetail />} />
                                   {/* <Route path="/about-us" element={<AboutUs />} /> */}
                                   <Route path="/product" element={<Product />} />
                                   <Route path="/integrations" element={<Integrations />} />
                                   <Route path="/use-cases/:topic" element={<HomeUseCases />} />
                                   <Route path="/use-cases" element={<UseCases />} />
                                   <Route path="/pricing" element={<Pricing />} />
                                   <Route path="/faq" element={<FAQ2 />} />
                                   <Route path="/contact" element={<Contact2 />} />
                                   <Route path="/terms-condition" element={<TermsConditions />} />
                                   <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                                   <Route path="/refund-policy" element={<RefundPolicy />} />
                                   <Route path="/customer-support" element={<CustomerSupport />} />
                                   <Route path="/security" element={<Security />} />
                                   <Route path="/features" element={<FeaturesAll />} />
                                   <Route path="/*" element={<PageNotFound />} />
                            </Route>
                            {/* </Route> */}
                     </Routes>
              </>
       );
}

export default App;